import { api } from "../../index";

const tags = ["Contractors"];

export const contractorsApi = api.enhanceEndpoints({ addTagTypes: tags }).injectEndpoints({
  endpoints: (builder) => ({
    getContractors: builder.query({
      query: (params) => ({
        url: "Contractor/page",
        method: "GET",
        params: params,
      }),
      providesTags: tags,
    }),

    createEditContractors: builder.mutation({
      query: (body) => ({
        url: "Contractor",
        method: "POST",
        body: body,
      }),
      invalidatesTags: (_, error) => (error ? [] : tags),
    }),

    archiveContractors: builder.mutation({
      query: (id) => ({
        url: `Contractor/status/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (_, error) => (error ? [] : tags),
    }),
  }),
});

export const { useGetContractorsQuery, useLazyGetContractorsQuery, useCreateEditContractorsMutation, useArchiveContractorsMutation } = contractorsApi;
